import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { SocialShare } from 'widget/player-widget';

import reportStats from 'widget/redux/server/actions/stats/report';

import STATS_EVENTS from 'shared/constants/stats/events';

import { getChannelForWidget } from 'shared/selectors/channels';

import Icon from 'shared/components/icon/icon';
import { WixConnect } from 'shared/utils/wix-connect';

import { openModal, closeCatcher } from 'shared/components/modal/modal';
import { openPreviewPrompt } from 'widget/components/preview-prompt/preview-prompt';

import styles from './share-video.styl';


@connect(state => ({
  channelData: getChannelForWidget(state),
  appSettings: state.appSettings,
}), {
  reportStats,
})
@WixConnect(styles)
class ShareContent extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    channelData: React.PropTypes.object,
    getContentToShare: React.PropTypes.func,
    getShareUrl: React.PropTypes.func,
    reportStats: React.PropTypes.func,
  };

  constructor(props) {
    super(props);

    const { getShareUrl } = this.props;

    this.state = {
      url: getShareUrl(),
    };
  }

  @autobind
  changeUrl(event) {
    this.setState({
      url: event.target.value,
    });
  }

  @autobind
  sendStatsReport(name) {
    const { reportStats, channelData } = this.props;

    reportStats(STATS_EVENTS.CHANNEL_SHARE, {
      network: {
        name,
      },
      channel: channelData,
    });
  }

  render() {
    const { url } = this.state;
    const { getContentToShare, appSettings } = this.props;

    return (
      <div>
        <input type="text"
               onChange={this.changeUrl}
               value={url}
               className={styles['url-input']} />
        <SocialShare networks={['facebook', 'twitter', 'pinterest', 'tumblr']}
                     className={styles['share-container']}
                     buttonClassName={styles['share-button']}
                     content={getContentToShare(url)}
                     appSettings={appSettings}
                     onAfterClicked={this.sendStatsReport}
                     openPreviewPrompt={openPreviewPrompt} />
      </div>
    );
  }

}

export default class BaseShareControl extends React.Component {

  static propTypes = {
    children: React.PropTypes.object,
    className: React.PropTypes.string,
  };

  @autobind
  openSharePopup() {
    openModal({
      title: <FormattedMessage {...this.title} />,
      content: (
        <ShareContent getContentToShare={this.getContentToShare}
                      getShareUrl={this.getShareUrl} />
      ),
    })
      .catch(closeCatcher);
  }

  get content() {
    const count = React.Children.count(this.props.children);
    const { children } = this.props;

    if (count > 0) {
      return children;
    }

    return (
      <Icon name="share"
            styleName="icon" />
    );
  }

  render() {
    const { className } = this.props;

    return (
      <div styleName="share"
           className={className}
           onClick={this.openSharePopup}>
        {this.content}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/widget/components/share-mobile/share-base.js